import React from "react";
import {jsonLdScript, pageSchema} from "../../helper/schema";
import {images} from "../../constant";
import {Helmet} from "react-helmet";
import {BASE_URL} from "../../helper";
import {Range} from "rc-slider";
import CommonStaticSidebar from "./commonStaticSidebar";
import BestSellerGrid from "./bestSellerGrid";


import CustomerReviews from "../Common/CustomerReviews";
class About extends React.Component {

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <>
                <React.Fragment>
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>Farmer's Fresh Meat - About-us</title>
                        <meta name="description" content="Farmer's Fresh Meat is proud to be the best butcher shop and meat market in Houston, Texas. Buy wholesale beef, goat meat, chicken, and more - on sale now!"/>
                        <meta name="robots" content="index, follow"/>
                        <meta name="googlebot" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"/>
                        <meta property="og:type" content="article"/>
                        <meta property="og:title" content="Farmer's Fresh Meat - Voted Best Meat Market/Butcher Shop in Houston"/>
                        <meta property="og:description" content="Farmer's Fresh Meat is proud to be the best butcher shop and meat market in Houston, Texas. Buy wholesale beef, goat meat, chicken, and more - on sale now!"/>
                        <meta property="og:url" content={BASE_URL() + this.props.location.pathname}/>
                        <meta property="og:site_name" content="Farmer&#039;s Fresh Meat: Houston Meat Market &amp; Butcher Shop"/>
                        <meta property="article:publisher" content="https://www.facebook.com/farmersfreshmeat"/>
                        <meta property="og:image" content={images.logoImg}/>
                        <meta property="og:image:width" content="1449"/>
                        <meta property="og:image:height" content="1024"/>
                        <meta name="twitter:card" content="summary"/>
                        <meta name="twitter:creator" content="Farmerfreshmeat"/>
                        <meta name="twitter:site" content="Farmerfreshmeat"/>
                        <link rel="canonical" href={BASE_URL() + this.props.location.pathname}/>
                        {jsonLdScript(pageSchema({type: 'AboutPage', name: "Farmer's Fresh Meat - About-us", pathname: this.props.location.pathname}))}
                    </Helmet>
                    <div className="about-banner">
                        <div className="image-wrap">
                            <div className="img-content">
                                <img
                                    src={images.about}
                                    alt=""
                                    className="img-fluid"
                                />
                            </div>
                            <div className="overlay"></div>
                        </div>
                        <div className="banner-content">
                            <h1 >About farmer's</h1>
                            <h5>Taste the best & fresh meat ever day with Farmer's Fresh Meat</h5>
                        </div>
                    </div>
                    <div className="container-fluid mb-fix about-content mt-3">
                        <div className="col-12">
                            <div className="row">
                                <CommonStaticSidebar />
                                <div className="col-md-9 emp-form">
                                    <div className="row">
                                        <div className="col-md-12 p-0">
                                            <div className="col-12 main-section bg-white p-4 text-left">
                                                <div className="title mb-0">
                                                    <h2 className="main-head">Who we are</h2>
                                                </div>
                                                <h6>Headquartered in Houston, Texas, Farmer’s is a family owned business and has remained so from the beginning.  Farmer’s Fresh Meat distinguishes itself from other meat market processors by fusing a southern style hospitality often accompanied with comfort foods with the implementation of unparalleled processing standards.</h6>
                                                <h6>Farmer’s Fresh Meat manufactures, processes, and distributes a wide variety of meat products. All of our meat arrives fresh every day and are custom cut and processed in-house to fulfill the needs of the thousands of customers. We also specialize in game processing and producing southern style favorites, such as Farmer’s Homemade Boudin and Stuffed Cornish Hens.</h6>
                                            </div>
                                        </div>
                                        <div className="col-md-12 p-0">
                                            <div className="col-12 main-section bg-white p-4 text-left">
                                                <div className="title mb-0">
                                                    <h2 className="main-head">Our mission</h2>
                                                </div>
                                                <div className="title px-0">
                                                    <h2 className="">We hope to see you soon and remember: “Fresh is Best!”</h2>
                                                </div>
                                                <h6>It is our mission to provide our loyal customers the freshest and cleanest meat shopping experience with a touch of our southern hospitality. To fulfill that goal, we receive our meat fresh every day and masterfully carve it to your liking – the old fashioned way. Armed with butcher cleavers and boning knives, our experienced butchers will carve your choice of meat to the exact specifications you desire. To ensure the freshness and quality of meat, we go above and beyond industry standards by having separate band saws, slicers, knives, and prep tables for beef, chicken, and pork. Our dedicated staff is friendly, knowledgeable, and will make your satisfaction the number one priority.</h6>
                                            </div>
                                        </div>
                                        <div className="col-md-12 p-0">
                                            <div className="col-12 main-section bg-white p-4 text-left">
                                                <div className="title mb-0">
                                                    <h2 className="main-head">Community</h2>
                                                </div>
                                                <div className="title px-0">
                                                    <h2 className="">Farmer’s Fresh Meat is proud to be called, “the pride of Sunnyside!”</h2>
                                                </div>
                                                <h6>
                                                    Farmer’s firmly believes in giving back to the community that helped it become the true success story it is today. That is why Farmer’s has sponsored many social events in the Sunnyside Community and has sponsored the Houston Police Department Fun Day events on multiple occasions. Farmer’s also continues to set aside a portion of funds every month, dedicated to the social welfare of the Houston community.</h6>
                                            </div>
                                        </div>
                                        <div className="col-12 text-center title mb-3 mt-3">
                                            <h2 className="main-head">Checkout Our Bestsellers</h2>
                                            <BestSellerGrid />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                <CustomerReviews/>
                </React.Fragment>
            </>
        );
    }
}

export default About;



